
<template>
  <div id="chart3"
       style="width:100%; height:90%;"></div>
</template>
<script>
import echarts from "echarts";
export default {
  props: ['width', "height", 'xData', 'series', 'x', 'y'],
  //xData =['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12 (月)']
  //series=  option.series[0].data = [21, 25, 27, 12, 22, 21, 25, 27, 12, 22, 42, 32];
  data () {
    return {
    }
  },
  watch: {

    series: {
      handler: function () {
        this.initchart()
      },
      deep: true    }
  },
  mounted () {
    this.initchart()

  },
  methods: {
    initchart () {
      let option = {
        tooltip: {
          trigger: "axis" // axis   item   none三个值
        },
        grid: {
          // 控制图的大小，调整下面这些值就可以，
          x: "15%",
          x2: "15%",
          y2: '10%',// y2可以控制 X轴跟Zoom控件之间的间隔，避免以为倾斜后造成 label重叠到zoom上
          y: '20%'
        },
        backgroundColor: '#001848',
        xAxis: {
          name: this.x,
          type: 'category',
          axisTick: {
            show: true,
          },
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 12 * this.$store.state.ratio.hole,
            color: '#fff',
            interval: 1
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
              width: 2,
            }
          },
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 12 * this.$store.state.ratio.hole,
            color: "#fff"
          }
        },

        yAxis: {
          name: this.y,
          type: 'value',
          axisTick: {
            show: true,//不显示刻度线
          },
          axisLabel: {
            fontSize: 12 * this.$store.state.ratio.hole,
            color: '#fff'  //y轴上的字体颜色
          },
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 12 * this.$store.state.ratio.hole,
            color: "#fff"
          },
          axisLine: {
            lineStyle: {
              width: 2 * this.$store.state.ratio.hole,
              color: '#fff',//y轴的轴线的宽度和颜色
            }
          },
          splitLine: {
            show: true
          }

        },
        series: [
          {
            type: 'line',
            // symbol: 'none',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#09b0f5',
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#09b0f5'
                }, {
                  offset: 1,
                  color: 'rgba(12,102,173,.5)'
                }])
              }
            },
          }
        ]
      };
      option.xAxis.data = this.xData || ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
      option.series[0].data = this.series;
      var myChart = echarts.init(this.$el);
      myChart.getDom().style.height = this.height
      myChart.getDom().style.width = this.width
      myChart.setOption(option);
    }
  }
}
</script>
<style scoped>
canvas {
  width: 100%;
}
</style>